<template>
    <el-submenu v-if="menu.children && menu.children.length>0" :key="menu.meta.menuId" :index="menu.meta.menuId">
      <template slot="title">
          <span class="menu-icon iconfont" :class="'icon'+menu.meta.icon"></span>
          <span> {{menu.meta.zhname}}</span>
      </template>
      <el-menu-item-group class="menu-child-group">
        <template v-for="child in formatMenu(menu)">
          <menu-item :menu="child" :key="child.id"></menu-item>
        </template>
      </el-menu-item-group>
    </el-submenu>
    <el-menu-item v-else  :key="menu.meta.menuId" :index="menu.meta.menuId"  @click="goTab(menu)">
      <span class="menu-icon iconfont" :class="'icon'+menu.meta.icon"></span>
      <span> {{menu.meta.zhname}}</span>
    </el-menu-item>
</template>
<script>
// import MenuItem from './MenuItem'
export default {
  name: 'menuItem',
  props: {
    menu: {}
  },
  components: {
    // MenuItem
  },
  data () {
    return {}
  },
  created () {
  },
  methods: {
    formatMenu (tree) {
      if (!(tree instanceof Array)) {
        tree = tree.children
      }
      return tree.filter(item => {
        return item.meta.type === 'menu'
      })
    },
    goTab (menu) {
      this.$router.push({name: menu.name})
    }
  }
}
</script>
<style lang='less'>
.menu-title{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/SideMenu/MenuItem.vue